// extracted by mini-css-extract-plugin
export default {"root":"Worm__root--qiCcB","btn":"Worm__btn--31B7Z","btn_new":"Worm__btn_new--38xoZ"};